import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";

class ConciergeReports extends Component {
    constructor(props) {
        super(props);
        if (this.props.user.canViewConciergeReports !== true) {
            this.props.history.replace("/reports");
        }
    }

    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Concierge Reports</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/concierge/tee-time-booking-outcomes'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Tee-Time Booking Outcomes
                                </h3>
                                <p className='card-text'>
                                    View booked and cancelled tee-time outcomes
                                    by claimed staff member and month.
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.user.canViewConciergeReports !== true) {
            return null;
        }

        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default ConciergeReports;
